var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "image-upload-container" },
      [
        _vm.fileList.length < _vm.limit
          ? _c(
              "div",
              {
                staticClass: "image_poster",
                staticStyle: { width: "150px", height: "150px" },
                on: { click: _vm.handleGetImgUrl },
              },
              [
                _c("i", { staticClass: "el-icon-plus" }),
                _c("span", [_vm._v("点击上传图片")]),
              ]
            )
          : _vm._e(),
        _c(
          "draggable",
          _vm._b(
            {
              staticClass: "upload-items",
              attrs: {
                list: _vm.fileList,
                tag: "div",
                draggable: ".draggle",
                move: _vm.handleMove,
              },
            },
            "draggable",
            {
              animation: 500,
              handle: ".draggle",
            },
            false
          ),
          _vm._l(_vm.fileList, function (item, index) {
            return _c(
              "div",
              { key: index, staticClass: "draggle" },
              [
                _c("ImagePreviewer", {
                  staticClass: "el-upload-list__item-thumbnail",
                  attrs: {
                    src: item.materialUrl || item.coverUrl,
                    fit: "contain",
                    "preview-src-list": [item.materialUrl || item.coverUrl],
                  },
                }),
                _c("div", { staticClass: "upload-delete" }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/image/icon_close.png"),
                      alt: "",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.handleClose(index)
                      },
                    },
                  }),
                ]),
              ],
              1
            )
          }),
          0
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "tips m-t-20" },
      _vm._l(_vm.tips, function (item) {
        return _c("div", { key: item }, [_vm._v(_vm._s(item))])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }